import NativeSafeAreaProvider from './specs/NativeSafeAreaProvider';

export { NativeSafeAreaProvider };
